
var c="AirCon";
var selector = 0;
var currency = "AUD";
var shippingEconomy = "0.00";
var shippingExpress = "9.99";
var shipping = "0.00";
var postalService ="Australia Post";

var priceUniversal ="";
var priceAlternative="";
var categoryName ="";

var url_string = window.location.href;
var url = new URL(url_string);
//var c = url.searchParams.get("c");
var q = url.searchParams.get("q");
if(q==null){var q="AirCon";}
//var originalSearch="search?type=product";
//var fixedc= "&c="+ c +"&q="+q;
//var searchText = originalSearch + fixedc + "&fsearch=" + q + "%20" + c + "%20Remote&site=Australiaremotes";
//var check = url_string.includes("fsearch");
//var checkType = url_string.includes("search?");
//var checkPage = url_string.includes("page");
//var ultimateCheck = check + checkPage;
//if (ultimateCheck == false) {
//if ((checkType== true) && (q !== null && q !== "")){
//window.location.replace(searchText);
//}  }
//                     AIR   TV     DVD    PROJ  Bluray VHS    garage  fan     fire   sat    none
var priceUniversal = [54,23.99, 19.99, 19.99, 19.99, 23.99, 19.99,  19.99, 19.99,  19.99, 19.99]
var priceAlternative=[89,39, 29.99, 39.99, 39.99, 29.99, 29.99,  39.99, 29.99,  39.99, 29.99]
var priceOriginal =  [149,79.99, 34.99, 39.99, 49.99, 29.99, 34.99,  39.99, 49.99,  29.99, 89.99]
var categoryName = ['Device', 'Television', 'DVD', 'Projector', 'Blu Ray', 'VHS', 'Garage', 'Fan', 'Fireplace', 'Satellite', 'Device'];

if      (c.includes("AirCon")) { selector = 0; }
else if (c.includes("TV")) { selector = 1; }
else if (c.includes("DVD")) { selector = 2;}
else if (c.includes("Projector")) {selector = 3;}
else if (c.includes("Blu")) { selector = 4;}
else if (c.includes("VHS")) { selector = 5;}
else if (c.includes("Garage")) {selector = 6; }
else if (c.includes("Fan")) { selector = 7; }
else if (c.includes("Fire")) {selector = 8; }
else if (c.includes("Satellite")) {selector = 9;}
else if (c.includes("AirCon")) {selector = 0;};
document.getElementById('quantity').value = 1;
document.getElementById("categoryTextTop").innerHTML = categoryName[selector];
document.getElementById("categoryTextMiddle").innerHTML = categoryName[selector];
document.getElementById('universalPrice').innerHTML = priceUniversal[selector];
document.getElementById('alternativePrice').innerHTML = priceAlternative[selector];
document.getElementById('officialPrice').innerHTML = priceOriginal[selector];
document.getElementById('postalService').innerHTML = postalService;





            var quantity = document.getElementById('quantity').value;

//link maker
var priceOfUniversal = priceUniversal[selector];
var nameOfType = categoryName[selector];
var linkForUniversal = "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=shalatuniversali%40gmail%2ecom&lc=GB&item_name="+ quantity + " x " + q + " Compatible Universal " + nameOfType + " Remote&amount=" + priceOfUniversal + "&currency_code=" + currency + "&button_subtype=services&no_note=0&no_shipping=2&shipping="+shipping+"&bn=PP%2dBuyNow";
var priceOfAlternative = priceAlternative[selector];
var linkForAlternative = "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=shalatuniversali%40gmail%2ecom&lc=GB&item_name="+ quantity + " x " + q + " Compatible Substitute " + nameOfType + " Remote&amount=" + priceOfAlternative + "&currency_code=" + currency + "&button_subtype=services&no_note=0&no_shipping=2&shipping="+shipping+"&bn=PP%2dBuyNow";
var priceOfOfficial = priceOriginal[selector];
var linkForOfficial = "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=shalatuniversali%40gmail%2ecom&lc=GB&item_name="+ quantity + " x " + q + " RR Branded Replacement " + nameOfType + " Remote&amount=" + priceOfOfficial + "&currency_code=" + currency + "&button_subtype=services&no_note=0&no_shipping=2&shipping="+shipping+"&bn=PP%2dBuyNow";

//document.getElementById('alternativeLink').href = linkForAlternative;
//document.getElementById('universalLink').href = linkForUniversal;
//document.getElementById('officialLink').href = linkForOfficial;
document.getElementById('shippingPrice').innerHTML = shipping;
document.getElementById('link').href = linkForUniversal;
document.getElementById('cost').innerHTML = priceOfUniversal;
document.getElementById('link').innerHTML = 'Order now $' + priceOfUniversal;
window.onload = function(){

    var shipping_options = document.forms["shippingForm"].elements["shipping"];
    
    for(var i = 0, max = shipping_options.length; i < max; i++) {
        shipping_options[i].onclick = function() {
            var quantity = document.getElementById('quantity').value;
            shipping = this.value;
            linkForUniversal = "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=shalatuniversali%40gmail%2ecom&lc=GB&item_name="+ quantity + " x " + q + " Compatible Universal " + nameOfType + " Remote&amount=" + (quantity * priceOfUniversal) + "&currency_code=" + currency + "&button_subtype=services&no_note=0&no_shipping=2&shipping="+shipping+"&bn=PP%2dBuyNow";
            linkForAlternative = "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=shalatuniversali%40gmail%2ecom&lc=GB&item_name="+ quantity + " x " + q + " Compatible Substitute " + nameOfType + " Remote&amount=" + (quantity * priceOfAlternative) + "&currency_code=" + currency + "&button_subtype=services&no_note=0&no_shipping=2&shipping="+shipping+"&bn=PP%2dBuyNow";
            linkForOfficial = "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=shalatuniversali%40gmail%2ecom&lc=GB&item_name="+ quantity + " x " + q + " RR Branded Replacement " + nameOfType + " Remote&amount=" + (quantity * priceOfOfficial) + "&currency_code=" + currency + "&button_subtype=services&no_note=0&no_shipping=2&shipping="+shipping+"&bn=PP%2dBuyNow";
            document.getElementById('shippingPrice').innerHTML = shipping;
            var selectedCostOption;
                    
            for(var i = 0, max = document.getElementsByClassName('costOption').length; i < max; i++) {
                if (document.getElementsByClassName('costOption')[i].checked) {
                    selectedCostOption = document.getElementsByClassName('costOption')[i].value;
                    switch (selectedCostOption) {
                            case 'universal':
                                document.getElementById('link').href = linkForUniversal;
                                break;
                            case 'alternative':
                                document.getElementById('link').href = linkForAlternative;
                                break;
                            case 'official':
                                document.getElementById('link').href = linkForOfficial;
                                break;
                            default:
                                break;
                        }
                    }
            }
        }
    }

    var cost_options = document.forms["costForm"].elements["cost"];
    for(var i = 0, max = cost_options.length; i < max; i++) {
        cost_options[i].onclick = function() {
            var quantity = document.getElementById('quantity').value;
            linkForUniversal = "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=shalatuniversali%40gmail%2ecom&lc=GB&item_name="+ quantity + " x " + q + " Compatible Universal " + nameOfType + " Remote&amount=" + (quantity * priceOfUniversal) + "&currency_code=" + currency + "&button_subtype=services&no_note=0&no_shipping=2&shipping="+shipping+"&bn=PP%2dBuyNow";
            linkForAlternative = "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=shalatuniversali%40gmail%2ecom&lc=GB&item_name="+ quantity + " x " + q + " Compatible Substitute " + nameOfType + " Remote&amount=" + (quantity * priceOfAlternative) + "&currency_code=" + currency + "&button_subtype=services&no_note=0&no_shipping=2&shipping="+shipping+"&bn=PP%2dBuyNow";
            linkForOfficial = "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=shalatuniversali%40gmail%2ecom&lc=GB&item_name="+ quantity + " x " + q + " RR Branded Replacement " + nameOfType + " Remote&amount=" + (quantity * priceOfOfficial) + "&currency_code=" + currency + "&button_subtype=services&no_note=0&no_shipping=2&shipping="+shipping+"&bn=PP%2dBuyNow";
            switch (this.value) {
                case 'universal':
                    document.getElementById('cost').innerHTML = priceOfUniversal;
                    document.getElementById('link').href = linkForUniversal;
                    document.getElementById('link').innerHTML = 'Order now $' + priceOfUniversal +' + Shipping';
                    break;
                case 'alternative':
                    document.getElementById('cost').innerHTML = priceOfAlternative;
                    document.getElementById('link').href = linkForAlternative;
                    document.getElementById('link').innerHTML = 'Order now $' + priceOfAlternative +' + Shipping';
                    break;
                case 'official':
                    document.getElementById('cost').innerHTML = priceOfOfficial;
                    document.getElementById('link').href = linkForOfficial;
                    document.getElementById('link').innerHTML = 'Order now $' + priceOfOfficial +' + Shipping';
                    break;
                default:
                    break;
            }
        }
    }
  
    function quantityChange() {
        var quantity = document.getElementById('quantity').value;
        var selectedCostOption;
        var totalPrice;
        for(var i = 0, max = document.getElementsByClassName('costOption').length; i < max; i++) {
            if (document.getElementsByClassName('costOption')[i].checked) {
                selectedCostOption = document.getElementsByClassName('costOption')[i].value;
                linkForUniversal = "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=shalatuniversali%40gmail%2ecom&lc=GB&item_name="+ quantity + " x " + q + " Compatible Universal " + nameOfType + " Remote&amount=" + (quantity * priceOfUniversal) + "&currency_code=" + currency + "&button_subtype=services&no_note=0&no_shipping=2&shipping="+shipping+"&bn=PP%2dBuyNow";
                linkForAlternative = "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=shalatuniversali%40gmail%2ecom&lc=GB&item_name="+ quantity + " x " + q + " Compatible Alternative " + nameOfType + " Remote&amount=" + (quantity * priceOfAlternative) + "&currency_code=" + currency + "&button_subtype=services&no_note=0&no_shipping=2&shipping="+shipping+"&bn=PP%2dBuyNow";
                linkForOfficial = "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=shalatuniversali%40gmail%2ecom&lc=GB&item_name="+ quantity + " x " + q + " RR Branded Replacement " + nameOfType + " Remote&amount=" + (quantity * priceOfOfficial) + "&currency_code=" + currency + "&button_subtype=services&no_note=0&no_shipping=2&shipping="+shipping+"&bn=PP%2dBuyNow";
                switch (selectedCostOption) {
                    case 'universal':
                        totalPrice = quantity * priceOfUniversal;
                        document.getElementById('cost').innerHTML = totalPrice;
                        document.getElementById('link').href = linkForUniversal;
                        document.getElementById('link').innerHTML = 'Order now $' + totalPrice;
                        break;
                    case 'alternative':
                        totalPrice = quantity * priceOfAlternative;
                        document.getElementById('cost').innerHTML = totalPrice;
                        document.getElementById('link').href = linkForAlternative;
                        document.getElementById('link').innerHTML = 'Order now $' + totalPrice;
                        break;
                    case 'official':
                        totalPrice = quantity * priceOfOfficial;
                        document.getElementById('cost').innerHTML = totalPrice;
                        document.getElementById('link').href = linkForOfficial;
                        document.getElementById('link').innerHTML = 'Order now $' + totalPrice;
                        break;
                    default:
                        break;
                }
            }
        }
    }
  
    document.getElementById('quantity').oninput = quantityChange;

    var quantityBtns = document.getElementsByClassName('js--qty-adjuster');
    for(var i = 0; i < quantityBtns.length; i++) {
        quantityBtns[i].addEventListener("click", function(e) {
            e.preventDefault();
            quantityChange();
        });
    }
};